import React from "react";

import { randomIntFromInterval, generateText } from "../utils";

interface PlaceholderStatusContentProps {
  maxLength: number;
  minLength: number;
}

/** Fake status content while data is loading. */
const PlaceholderStatusContent: React.FC<PlaceholderStatusContentProps> = ({
  minLength,
  maxLength,
}) => {
  const length = randomIntFromInterval(maxLength, minLength);

  return (
    <div className="flex flex-col text-placeholder">
      <p className="wrap-break-word">{generateText(length)}</p>
    </div>
  );
};

export default PlaceholderStatusContent;
